import React from "react";
import ProjectHealthFieldProto from "./project-health-proto";

export default function renderProjectHealthInView(props) {
    return <ProjectHealthFieldProto renderMode="view" {...props} />;
}